import PropTypes from "prop-types"
import LinearProgressLoader from "~/components/LinearProgressLoader"
import DocCard from "../DocCard"

const DocList = ({ docs, isFetching, total }) => {
  const showData = docs?.length > 0 && !isFetching
  const showNoMatchesFound = docs?.length === 0 && !isFetching && total > 0
  const showNoDocs = total === 0 && !isFetching
  return (
    <>
      {isFetching && <LinearProgressLoader />}
      {showData && (
        <div className="flex gap-6 flex-wrap justify-center lg:justify-start px-8">
          {docs?.map((doc) => {
            return <DocCard doc={doc} key={doc.id} />
          })}
        </div>
      )}
      {showNoMatchesFound && (
        <div className="flex justify-center mt-10">No Matches Found</div>
      )}
      {showNoDocs && (
        <div className="flex justify-center mt-10">
          <h3>No Docs Found</h3>
        </div>
      )}
    </>
  )
}

DocList.propTypes = {
  docs: PropTypes.array,
  isFetching: PropTypes.bool,
  total: PropTypes.number,
}

export default DocList
